// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2_gBz","header":"ClearentDisclaimer_header__3YMc0","inner":"ClearentDisclaimer_inner__3RlF9"};